
import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { AttachedDocument } from 'types';

export type DisputeDocuments = {
    disputeNumber: string
    documents: AttachedDocument[]
};

export const uploadedDocumentList = atom<DisputeDocuments | null>({
    key: 'uploadedDocumentsList',
    default: undefined
});

export const useSetUploadedDocumentsList = () => useSetRecoilState(uploadedDocumentList);

export const useUploadedDocumentsList = () => useRecoilValue(uploadedDocumentList);

export const useUploadedDocumentsListState = () => useRecoilState(uploadedDocumentList);